// A Sound Lab setup (a period's sounds without a day): passed between the Planner and the Lab in
// the URL (`/admin/lab?setup=…`, base64url JSON).
import type { InstrumentRole, Key, KitId } from "@eb/shared";

export interface LabSetup {
  kit: KitId;
  key: Key;
  instruments: Record<InstrumentRole, string>;
  alternates: Record<InstrumentRole, [string, string]>;
  fx: { reverbSize: number; delayTicks: number };
  seed: number;
}

export function encodeSetup(s: LabSetup): string {
  const bytes = new TextEncoder().encode(JSON.stringify(s));
  let bin = "";
  for (const b of bytes) bin += String.fromCharCode(b);
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export function decodeSetup(v: string): LabSetup | null {
  try {
    const bin = atob(v.replace(/-/g, "+").replace(/_/g, "/"));
    const bytes = Uint8Array.from(bin, (c) => c.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes)) as LabSetup;
  } catch {
    return null;
  }
}
